module.exports = __webpack_public_path__ + "img/appAsset-brand--Discover.d3adf23b.svg";